import { bifrost } from '~/lib/bifrost'

export const generalService = bifrost.createNativeProxy<{
  close: () => Promise<void>

  logEvent: (payload: {
    event_name: string
    event_params?: Record<string, string>
  }) => Promise<void>

  openURL: (url: string) => Promise<void>

  pageReady: () => Promise<void>

  pageAbort: () => Promise<void>

  complete: () => Promise<void>

  getPageContext: () => Promise<{ initial_theme: number }>
}>('GeneralService')
